/* ============================================================
   GYAANSTORE - SHARED JS PRODUCT CARD + helpers (assets/gs-cards.js)
   Loaded once in theme.liquid.

   Exposes:
     window.gsFormatMoney(cents)         -> formats using the SHOP's money
                                            format (single-source currency).
     window.gsToCents(value)             -> normalises a price to integer cents.
     window.gsCard(data)                 -> returns a product-card DOM node that
                                            matches the grid (styled by gs-cards.css).
     window.gsRecordRecentlyViewed(item) -> remembers a viewed product.
     window.gsGetRecentlyViewed()        -> returns the remembered list.

   Single source for "how a JS product card looks + how money is formatted"
   so Series nav and Recently Viewed stay consistent with the storefront.
   ============================================================ */
(function () {
  // ---- Money (canonical Shopify formatter, fed by window.gsMoneyFormat) ----
  function delim(number, precision, thousands, decimal) {
    precision = (precision == null) ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? (decimal + parts[1]) : '';
    return whole + frac;
  }

  window.gsToCents = function (v) {
    // Accepts integer cents (24900), a major-unit string ("249.00"), or "24900".
    if (v == null || v === '') return null;
    if (typeof v === 'number') return Math.round(v);
    if (typeof v === 'string') {
      if (v.indexOf('.') !== -1) return parseInt(v.replace('.', ''), 10);
      return parseInt(v, 10);
    }
    return null;
  };

  window.gsFormatMoney = function (cents) {
    var fmt = window.gsMoneyFormat || '';
    if (!fmt || cents == null || isNaN(cents)) return '';
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount': return delim(cents, 2);
        case 'amount_no_decimals': return delim(cents, 0);
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_space_separator': return delim(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return delim(cents, 0, ' ');
        default: return delim(cents, 2);
      }
    });
    // TEMPORARY currency bridge: the shop's money_format is still "Rs. {{amount}}",
    // but the rest of the storefront shows the rupee sign, so match it for visual
    // consistency. (This file MUST be uploaded as UTF-8 bytes to keep the rupee
    // sign intact.) When the currency single-source refactor sets the shop money
    // format to the rupee sign at publish, this replace becomes a harmless no-op.
    var RUPEE = '₹';
    out = out.replace('Rs.', RUPEE).replace(/Rs\b/, RUPEE);
    return out;
  };

  // ---- Card builder ----
  // data = { url, title, image, priceCents, compareCents, badge, current, showName }
  window.gsCard = function (data) {
    data = data || {};
    var a = document.createElement('a');
    a.className = 'gs-pcard' + (data.current ? ' is-current' : '');
    a.href = data.url || '#';
    if (data.current) a.setAttribute('aria-current', 'true');
    if (data.title) a.setAttribute('aria-label', data.title);

    var media = document.createElement('div');
    media.className = 'gs-pcard__media';
    if (data.image) {
      var img = document.createElement('img');
      img.src = data.image;
      img.alt = data.title || '';
      img.loading = 'lazy';
      media.appendChild(img);
    }
    if (data.badge) {
      var b = document.createElement('span');
      b.className = 'gs-pcard__badge';
      b.textContent = data.badge;
      media.appendChild(b);
    }
    a.appendChild(media);

    var info = document.createElement('div');
    info.className = 'gs-pcard__info';

    // Title + price show on EVERY card (incl. the current one) so all cards look
    // identical to the storefront grid. The current item is set apart only by the
    // highlight ring + red badge (via the .is-current class), not by hiding info.
    if (data.showName && data.title) {
      var t = document.createElement('span');
      t.className = 'gs-pcard__title';
      t.textContent = data.title;
      info.appendChild(t);
    }

    var price = window.gsFormatMoney(data.priceCents);
    if (price) {
      var pw = document.createElement('span');
      pw.className = 'gs-pcard__price';
      var now = document.createElement('span');
      now.className = 'gs-pcard__now';
      now.textContent = price;
      var onSale = data.compareCents && data.compareCents > data.priceCents;
      if (onSale) now.classList.add('is-sale');
      pw.appendChild(now);
      if (onSale) {
        var was = document.createElement('span');
        was.className = 'gs-pcard__was';
        was.textContent = window.gsFormatMoney(data.compareCents);
        pw.appendChild(was);
      }
      info.appendChild(pw);
    }

    a.appendChild(info);
    return a;
  };

  // ---- Native Dawn slider builder ----
  // Builds the SAME swipable slider Dawn uses for "You may also like" / featured
  // collection: real product-grid widths (so card images render correctly) + the
  // slider classes for swipe. We append the fully-formed <slider-component> (slides
  // already inside) LAST, so its connectedCallback initialises with the right count.
  // Requires component-slider.css on the page (sections load it).
  window.gsBuildSlider = function (mount, lis, idBase) {
    if (!mount || !lis || !lis.length) return null;

    var sc = document.createElement('slider-component');
    sc.className = 'slider-mobile-gutter slider-component-desktop';

    var ul = document.createElement('ul');
    ul.id = idBase;
    ul.setAttribute('role', 'list');
    ul.className = 'grid product-grid contains-card contains-card--product contains-card--standard ' +
                   'grid--5-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek';
    lis.forEach(function (li) {
      if (li.classList && !li.classList.contains('slider__slide')) li.classList.add('slider__slide');
      ul.appendChild(li);
    });
    sc.appendChild(ul);

    // ICON CONSISTENCY (2026-06-06): use Dawn's NATIVE caret (the FILLED icon every
    // native carousel uses) instead of a custom stroked chevron, so all carousels
    // share one arrow. component-slider.css already rotates `.slider-button--prev
    // .icon` (90deg = points left) and `--next .icon` (-90deg = points right), and
    // the native caret carries `class="icon icon-caret"`, so BOTH buttons use the
    // SAME caret markup and the CSS handles the direction.
    var caret = '<span class="svg-wrapper"><svg class="icon icon-caret" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg></span>';
    var leftCaret = caret;
    var rightCaret = caret;
    var btns = document.createElement('div');
    btns.className = 'slider-buttons';
    btns.innerHTML =
      '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Previous" aria-controls="' + idBase + '">' + leftCaret + '</button>' +
      '<div class="slider-counter caption"><span class="slider-counter--current">1</span><span aria-hidden="true"> / </span>' +
      '<span class="slider-counter--total">' + lis.length + '</span></div>' +
      '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Next" aria-controls="' + idBase + '">' + rightCaret + '</button>';
    sc.appendChild(btns);

    mount.appendChild(sc);
    return sc;
  };

  // ---- Recently viewed store (localStorage) ----
  var RV_KEY = 'gs_recently_viewed';
  window.gsRecordRecentlyViewed = function (item) {
    if (!item || !item.handle) return;
    try {
      var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      list = list.filter(function (x) { return x.handle !== item.handle; });
      list.unshift(item);
      if (list.length > 20) list = list.slice(0, 20);
      localStorage.setItem(RV_KEY, JSON.stringify(list));
    } catch (e) { /* storage off - ignore */ }
  };
  window.gsGetRecentlyViewed = function () {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }
    catch (e) { return []; }
  };

  // ---- Shared cardonly fetch WITH CACHE (2026-07-05) ----
  // Recently-viewed (PDP) + Recently-viewed (home) + Series nav each fetch up to
  // 8-30 /products/<h>?view=cardonly pages — and repeat them on every navigation
  // (heavy on Indian mobile networks; flagged in the 7-05 audit as "fetch storms").
  // This helper gives all of them ONE cache: in-memory for the page, sessionStorage
  // across pages, 15-minute TTL so price/badge changes still surface quickly.
  // Failures are NOT cached, so a retry always refetches.
  var CARD_TTL = 15 * 60 * 1000;
  var cardMem = {};
  window.gsFetchCard = function (handle) {
    if (cardMem[handle]) return Promise.resolve(cardMem[handle]);
    var key = 'gsCard:' + handle;
    try {
      var hit = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (hit && hit.h && (Date.now() - hit.t) < CARD_TTL) { cardMem[handle] = hit.h; return Promise.resolve(hit.h); }
    } catch (e) { /* storage off/corrupt - fall through to network */ }
    return fetch('/products/' + encodeURIComponent(handle) + '?view=cardonly', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (html) {
          cardMem[handle] = html;
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), h: html })); } catch (e) { /* quota - memory cache still works */ }
        }
        return html;
      })
      .catch(function () { return ''; });
  };

  // ---- Shared carousel arrow wiring (2026-06-26) ----
  // ONE helper so every homepage collection carousel scrolls identically.
  // Pass the prev button, next button, and either the scroll track element or a
  // function that returns it (use a function when the track can be swapped at
  // runtime, e.g. recommendations' fallback -> history). Wires click-to-scroll
  // (~one viewport) and auto-disables a button when the track reaches that end.
  // Pairs with the shared .gs-cnav styles in gs-ui-fixes.css.
  window.gsWireCarousel = function (prevBtn, nextBtn, trackOrFn) {
    function track() { return typeof trackOrFn === 'function' ? trackOrFn() : trackOrFn; }
    function update() {
      var t = track(); if (!t) return;
      var maxLeft = t.scrollWidth - t.clientWidth - 2; // -2px = sub-pixel slack
      if (prevBtn) prevBtn.disabled = t.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = t.scrollLeft >= maxLeft;
    }
    function page(dir) {
      var t = track(); if (!t) return;
      t.scrollBy({ left: dir * Math.round(t.clientWidth * 0.9), behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { page(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { page(1); });
    var t0 = track();
    if (t0) t0.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    return update; // caller can re-run after swapping/rebuilding the track
  };
})();
